import moment from "moment";
import { formatDate, formatDateTime } from "../utils";

export const validatePhone = (phone: string) => {
  return String(phone)
    .toLowerCase()
    .match(/^[0-9]*$/);
};
export const isEqualTime = (value1: string, value2: string, type?: string) => {
  // if date1 or date2 is not valid date, return false;
  if (!moment(value1).isValid() || !moment(value2).isValid()) {
    return false;
  }
  const formatFn = type === "date" ? formatDate : formatDateTime;
  if (formatFn(value1) === formatFn(value2)) {
    return true;
  }
  return false;
};
